<template>
  <div class="agent_list_page">
    <div class="page-title">{{title}}</div>
    <page-search
      :layout="searchLayout"
      @search="search"
    ></page-search>
    <pageTable
      :loading="tableLoading"
      :col="col"
      :data="tableData"
      :total="total"
      :pageSize="pageSize"
      :pageIndex="page"
      @pageChange="pageChange"
      @pageSizeChange="pageSizeChange"
    ></pageTable>
  </div>
</template>
<script>
import pageTable from '@/components/pageCom/pageTable.vue'
import pageTableMixin from '@/components/pageCom/pageTableMixin.js'
import pageSearch from '@/components/pageCom/pageSearch.vue'
import { getCompanyList } from '@/api/newagent.js'
// import Vue from 'vue'
// import toolsOpe from './toolsOpe'
// Vue.component('toolsOpe', toolsOpe)
export default {
  name: 'agentlist',
  components: {
    pageTable, pageSearch
  },
  mixins: [pageTableMixin],
  data() {
    return {
      searchLayout: ['code', 'name', 'regDate'],
      queryNo: '', // 搜索的企业编码
      queryName: '', // 搜索的企业名称
      queryTime: [], // 搜索的时间
      col: [
        { field: 'org_no', title: '企业编码', width: 70, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'cust_name', title: '企业名称', width: 125, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'enterprise_domain', title: '企业域', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'user_name', title: '管理员', width: 125, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tel_no', title: '手机号码', width: 90, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'reg_time', title: '注册时间', width: 125, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true },
        { field: 'tool_name_text', title: '工具名称', width: 190, titleAlign: 'left', columnAlign: 'left', isResize: true, overflowTitle: true }
      ]
    }
  },
  computed: {
    title() {
      return this.$route.name === 'agentind' ? '工业列表' : '服务商列表'
    }
  },
  methods: {
    initPage() {
      this.queryNo = ''
      this.queryName = ''
      this.queryTime = []
    },
    // 搜索的参数
    search(query) {
      this.initTable()
      this.queryNo = query.code || ''
      this.queryName = query.name || ''
      this.queryTime = query.regDate || []
      this.getData()
    },
    // 根据路由调用接口方法
    getData() {
      let query = {
        rp: this.pageSize,
        'cur_page': this.page,
        type: this.$route.name === 'agentind' ? '1' : '2'
      }
      query = this.addQuery(query, 'cust_no', this.queryNo)
      query = this.addQuery(query, 'cust_name', this.queryName)
      query = this.addQuery(query, 'reg_time_start', this.queryTime[0])
      query = this.addQuery(query, 'reg_time_end', this.queryTime[1])
      this.tableLoading = true
      getCompanyList(query).then(res => {
        this.tableLoading = false
        if (res.code === 0) {
          this.tableData = res.result.data
          this.total = res.result.total
        } else {
          this.tableData = []
          this.total = 0
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
</style>
